var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "back_svg",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 127 127",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M122.01,38.78c-3.2-7.56-7.78-14.35-13.61-20.18-5.83-5.83-12.62-10.41-20.18-13.61-7.83-3.31-16.15-4.99-24.72-4.99s-16.89,1.68-24.72,4.99c-7.56,3.2-14.35,7.78-20.18,13.61-5.83,5.83-10.41,12.62-13.61,20.18C1.68,46.61,0,54.93,0,63.5s1.68,16.89,4.99,24.72c3.2,7.56,7.78,14.35,13.61,20.18,5.83,5.83,12.62,10.41,20.18,13.61,7.83,3.31,16.15,4.99,24.72,4.99s16.89-1.68,24.72-4.99c7.56-3.2,14.35-7.78,20.18-13.61,5.83-5.83,10.41-12.62,13.61-20.18,3.31-7.83,4.99-16.15,4.99-24.72s-1.68-16.89-4.99-24.72ZM101.1,101.1c-10.04,10.04-23.4,15.57-37.6,15.57s-27.55-5.53-37.6-15.57c-10.04-10.04-15.57-23.4-15.57-37.6s5.53-27.55,15.57-37.6c10.04-10.04,23.4-15.57,37.6-15.57s27.55,5.53,37.6,15.57c10.04,10.04,15.57,23.4,15.57,37.6s-5.53,27.55-15.57,37.6Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M54,63.61l21.76-21.76c2.02-2.02,2.02-5.3,0-7.32-2.02-2.02-5.3-2.02-7.32,0l-25.42,25.42c-2.02,2.02-2.02,5.3,0,7.32,0,0,.01.01.02.02,0,0,.01.01.02.02l25.15,25.15c1.01,1.01,2.33,1.52,3.66,1.52s2.65-.51,3.66-1.52c2.02-2.02,2.02-5.3,0-7.32l-21.54-21.54Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.7aca437e7002be0c62dd2fc6b9d5ee00.svg";
export { ForwardRef as ReactComponent };